// import update from "immutability-helper";
import { isSet } from "../../Utils/CommonFunctions";
import {
    SET_RATESHEET_TABLE_RECORDS,
    RESET_RATESHEET_TABLE_RECORDS,
    UPDATE_RATESHEET_TABLE_RECORDS,
    UPDATE_RATESHEET_PAYLOAD,
    UPDATE_RATESHEET_CELLS,
    SELECT_RATESHEET_ROWS,
    CLEAR_OR_SELECT_ALL_ROWS
} from "../actionTypes/RateSheetActionTypes";
import {
  updateInputAndOutputAtt
} from '../../Containers/ShippingContainer/ShippingFunction';
// import { defaultPerpageUsingWindowId,getUserInfo } from '../../Utils/UserFunctions';

const rateSheetTableRecordsObj = {
  tableHead:[],
  tableData:{data:[],status:1000}, 
  selectedRows:[],
  isSelectAll:false,
  pagination:{
    page:0,
    orderBy:'',
    perPage:10,
    direction:'ASC',
    totalRecords:0,
    search:''
  }
};
const initialState = {
  rateSheetTableRecords:{
    ...rateSheetTableRecordsObj,
  },
  rateSheetPayload:[],
  variablesAndFields:[],
};


const RateSheetReducer = (state = initialState, action) => {

  let updaterateSheetTableRecords = null,tableKey = null,updateValue=null, updateRateSheetPayload = null,bool=null,rowId=null;
  const {rateSheetTableRecords,rateSheetPayload} = state;
  const {type,payload} = action;
  switch (type) {
    case SET_RATESHEET_TABLE_RECORDS:
        updaterateSheetTableRecords = {...payload};
        return {
            ...state,
            rateSheetTableRecords:updaterateSheetTableRecords
        }
    case RESET_RATESHEET_TABLE_RECORDS:
      updaterateSheetTableRecords = {...rateSheetTableRecordsObj};
      return {
        ...state,
        rateSheetTableRecords:updaterateSheetTableRecords
      }   
    case UPDATE_RATESHEET_TABLE_RECORDS:
      tableKey = payload.tableKey;
      updateValue = payload.updateValue;
      updaterateSheetTableRecords = {
        ...rateSheetTableRecords,
        [tableKey]:updateValue
      }
      return{
        ...state,
        rateSheetTableRecords:updaterateSheetTableRecords
      }  
    case UPDATE_RATESHEET_CELLS:
      const cellsObj = payload.cellsObj;
      updateValue    = payload.updateValue;
      const {type,id,cellIndex,headerName} = cellsObj;
      rowId = cellsObj.rowId;
      const inputType = type;      
      updaterateSheetTableRecords = {
        ...rateSheetTableRecords,
        tableData:{
          data:[...rateSheetTableRecords.tableData.data].map((itm,itmIndex)=>{
            let returnData = {...itm};
            if(itmIndex===cellIndex){
              returnData = {
                ...returnData,
                data:{
                  ...returnData['data'],
                  [headerName.toString().toLowerCase()]:{
                    ...returnData['data'][headerName.toString().toLowerCase()],
                    id:isSet(id,''),
                    value:isSet(updateValue,''),
                  },

                }
              }
            }
            return returnData;
          }),
          status:200
        }
      };
      // console.log('updaterateSheetTableRecords',updaterateSheetTableRecords);
      updateRateSheetPayload = [...rateSheetPayload];
      let dataIndex = null;
        if(rowId===null){
          dataIndex = updateRateSheetPayload.findIndex((a)=>a.cellIndex===cellIndex);
        }else{
          dataIndex = updateRateSheetPayload.findIndex((a)=>a.id===rowId);
        }
        if(dataIndex=== -1){
            dataIndex = updateRateSheetPayload.length;
            updateRateSheetPayload.push({
              id:rowId,
              dataIndex:dataIndex,
              cellIndex:cellIndex,
              inputAttributes:{},
              outputAttributes:{}
            });
        }
        //console.log('updateRateSheetPayload==',updateRateSheetPayload);
        if(inputType==='INPUT')
          updateRateSheetPayload = updateInputAndOutputAtt(updateRateSheetPayload,'inputAttributes',dataIndex,cellsObj,updateValue);
        else  
          updateRateSheetPayload = updateInputAndOutputAtt(updateRateSheetPayload,'outputAttributes',dataIndex,cellsObj,updateValue);

      return{
        ...state,
        rateSheetTableRecords:updaterateSheetTableRecords,
        rateSheetPayload:updateRateSheetPayload
      }  
    case UPDATE_RATESHEET_PAYLOAD:
      updateRateSheetPayload = [
        ...payload
      ];
      return{
        ...state,
        rateSheetPayload:updateRateSheetPayload
      }   
    case SELECT_RATESHEET_ROWS:
      bool = payload.bool;
      rowId = payload.rowId;
      updaterateSheetTableRecords = {
        ...rateSheetTableRecords,
      }
      
      let selectedRowsArr = [...isSet(updaterateSheetTableRecords.selectedRows,[])];
      if(bool===true){
        selectedRowsArr.push(rowId);
      } else{
        selectedRowsArr = [...isSet(updaterateSheetTableRecords.selectedRows, [])].filter((selRows) => {
          return rowId !== selRows;  // return true if you want to keep the item, false otherwise
        });
      }
      return{
        ...state,
        rateSheetTableRecords:{
          ...updaterateSheetTableRecords,
          isSelectAll:false,
          selectedRows:selectedRowsArr
        }
      }  
    case CLEAR_OR_SELECT_ALL_ROWS:
      updaterateSheetTableRecords = {
        ...rateSheetTableRecords,
      }
      bool = payload.bool;
      let selectedRows = [...isSet(updaterateSheetTableRecords.selectedRows,[])];
      let isSelectAll = false;      
      if(bool) {
        isSelectAll = true;
        // updaterateSheetTableRecords.tableData.data.map((item,index)=>{
        //   if(selectedRows.indexOf(isSet(item.rowId,index)) === -1){
        //       selectedRows.push(isSet(item.rowId,index));
        //   }
        // });
      }else {
        isSelectAll = false;
        selectedRows = [];
      }
      //console.log('rateSheetTableRecords==',rateSheetTableRecords)
    return{
      ...state,
      rateSheetTableRecords:{
        ...updaterateSheetTableRecords,
        selectedRows:selectedRows,
        isSelectAll:isSelectAll
      }
    }  
    default:
      return state;
  }
};


export default  RateSheetReducer;
